import {useMutation} from "react-query";
import apiClient from "../../helpers/apiClient.js";

export const usePatchVideo = () => {
  return useMutation(({videoId, ...props}) => apiClient.post(`/videos/operation_date/${videoId}`, {
    ...props
  }))
}
